module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr24-5ad81dd4c702f2b4bd539970e930e7b4.jpg";